import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

const config = {
  apiKey: "AIzaSyAiBgDkKcRTTQdWy1QcB5SPK7MGgHOXkiA",
  authDomain: "scrumcomms.firebaseapp.com",
  databaseURL: "https://scrumcomms.firebaseio.com",
  projectId: "scrumcomms",
  storageBucket: "scrumcomms.appspot.com",
  messagingSenderId: "232389961795"
};

// Export plain firebase object to be used for certain static methods like:
//  - Persistance
//  - GoogleAuthProvider
export const FirebaseConsts = firebase;
export default firebase.initializeApp(config);

export const db = firebase.firestore();
export const Storage = firebase.storage();
db.settings({
  timestampsInSnapshots: true
});



// WEBPACK FOOTER //
// ./src/firebaseConfig.js